import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import QuestionTypes from 'types/QuestionTypes';
import SimpleQuestionForm from '../SimpleQuestion/SimpleQuestionForm';
import ConnectionsGridForm from '../ConnectionsGrid/ConnectionsGridForm';
import ImagePinForm from '../ImagePin/ImagePinForm';

type Props = {
  questionRef: string;
}

const QuestionForm: FC<Props> = ({ questionRef }) => {
  const { watch } = useFormContext();

  const watchedQuestions = watch('questions');
  const question = watchedQuestions.find((q: any) => q.ref === questionRef);

  if (!question) return null;

  if (question.type === QuestionTypes.ConnectionGrid) {
    return <ConnectionsGridForm questionRef={questionRef} />;
  }

  if (question.type === QuestionTypes.ImagePin) {
    return <ImagePinForm questionRef={questionRef} />;
  }

  return <SimpleQuestionForm questionRef={questionRef} />;
};

export default QuestionForm;
